import type { ApplicationStatus } from "../features/application/application-types"
import { FLAG_SEPARATOR } from "../features/application/device-flags"
import type { AppRoutes } from "../routes/routes"

function buildUrl(route: AppRoutes, status: ApplicationStatus, appTypeId?: number, flags?: string[]): string {
    if (!appTypeId) {
        return ""
    }

    const basePath = route.replace(":id", `${appTypeId}`)
    const query = new URLSearchParams({ status })

    if (flags && flags.length > 0) {
        query.append("flags", flags.join(FLAG_SEPARATOR))
    }

    return `${basePath}?${query.toString()}`
}

export function prepareUrl(route: AppRoutes, status: ApplicationStatus, appTypeId?: number): string {
    return buildUrl(route, status, appTypeId)
}

export function prepareUrlWithFlags(
    route: AppRoutes,
    status: ApplicationStatus,
    appTypeId?: number,
    flags?: string[]
): string {
    return buildUrl(route, status, appTypeId, flags)
}
